exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-class[data-v-49d4510c] {\n  text-align: left;\n  height: 0.166667rem;\n  line-height: 0.166667rem;\n  margin-right: 0.052083rem;\n}\n[data-v-49d4510c] .el-input {\n  width: 1.666667rem;\n}", ""]);

// exports
